import { render } from "./NavbarSubsidiary.vue?vue&type=template&id=48a293e5"
import script from "./NavbarSubsidiary.vue?vue&type=script&lang=js"
export * from "./NavbarSubsidiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__